import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { InstitutionMailTemplate, MailTemplateType } from '../entities/mail-templates.js';

defineMailTemplate(MailTemplateType.FREE_FORM, {
  getMailData: arg1 => ({ data: {}, attachments: {}, scope: 'default' }),
  defaultTemplate: {
    subject: 'Kontaktaufnahme',
    content: ``,
    footer: '',
  },
  variables: InstitutionMailTemplate.getAvailableVariables(MailTemplateType.FREE_FORM),
  attachments: [],
  displayName: 'Freie Mail',
  editorHint: () => InstitutionMailTemplate.getMailHint(MailTemplateType.FREE_FORM),
});
